import { Box, Typography, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CategoryChip } from "@/components/CategoryChip";
import { TimeAgo } from "@/components/TimeAgo";
import type { Article } from "@/types";

export function ArticleListItem({ article }: { article: Article }) {
  const navigate = useNavigate();

  return (
    <>
      <Box
        sx={{
          py: 2,
          cursor: "pointer",
          "&:hover .article-title": { color: "secondary.main" },
        }}
        onClick={() => navigate(`/clanak/${article.id}`)}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
          <CategoryChip name={article.category.name} clickable={false} />
          <TimeAgo date={article.createdAt} />
        </Box>
        <Typography
          className="article-title"
          variant="h6"
          sx={{ mb: 0.5, lineHeight: 1.3, transition: "color 0.15s" }}
        >
          {article.title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {article.subtitle}
        </Typography>
      </Box>
      <Divider />
    </>
  );
}
